/** Maximum number of venues that can be compared simultaneously. */
export const MAX_COMPARE_SLOTS = 4;

/** Shadow style applied to the sticky left label column when horizontally scrolled. */
export const STICKY_LABEL_SHADOW: React.CSSProperties = {
  boxShadow: "4px 0 8px -2px rgba(0,0,0,0.1)",
  clipPath: "inset(0 -12px 0 0)",
};
